<div class="privacy-popup-overlay" *ngIf="isVisible" (click)="closePopup()">
  <div class="privacy-popup-container" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="privacy-popup-header">
      <div class="privacy-popup-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h2 class="privacy-popup-title">Privacy Agreement Required</h2>
      <p class="privacy-popup-subtitle">Please review and accept our privacy policy to continue</p>
    </div>

    <!-- Content -->
    <div class="privacy-popup-content">
      <div class="privacy-text">
        <h3>Privacy Policy & Terms of Service</h3>
        
        <h4>1. Information We Collect</h4>
        <p>We collect personal information that you provide directly to us, such as when you create an account, use our services, or contact us for support. This may include:</p>
        <ul>
          <li>Personal identification information (name, email address, phone number)</li>
          <li>Family relationship information</li>
          <li>Profile information and photos</li>
          <li>Communication preferences</li>
        </ul>

        <h4>2. How We Use Your Information</h4>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide and maintain our family management services</li>
          <li>Process your account registration and manage your profile</li>
          <li>Send you important updates about our services</li>
          <li>Improve our services and develop new features</li>
          <li>Ensure the security and integrity of our platform</li>
        </ul>

        <h4>3. Information Sharing</h4>
        <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy. We may share information:</p>
        <ul>
          <li>With other family members you choose to connect with</li>
          <li>When required by law or to protect our rights</li>
          <li>With service providers who assist us in operating our platform</li>
        </ul>

        <h4>4. Data Security</h4>
        <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>

        <h4>5. Your Rights</h4>
        <p>You have the right to:</p>
        <ul>
          <li>Access and update your personal information</li>
          <li>Request deletion of your account and data</li>
          <li>Opt out of certain communications</li>
          <li>Request a copy of your data</li>
        </ul>

        <h4>6. Contact Us</h4>
        <p>If you have any questions about this privacy policy, please contact us at privacy&#64;familitive.com</p>

        <div class="privacy-links">
          <p><strong>For complete details, please read our full documents:</strong></p>
          <div class="document-links">
            <a href="/privacy-policy" target="_blank" class="document-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" stroke-width="2"/>
                <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2"/>
                <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="2"/>
                <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="2"/>
                <polyline points="10,9 9,9 8,9" stroke="currentColor" stroke-width="2"/>
              </svg>
              Full Privacy Policy
            </a>
            <a href="/terms-of-service" target="_blank" class="document-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" stroke-width="2"/>
                <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2"/>
                <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="2"/>
                <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="2"/>
                <polyline points="10,9 9,9 8,9" stroke="currentColor" stroke-width="2"/>
              </svg>
              Terms of Service
            </a>
          </div>
        </div>

        <p class="privacy-updated">Last updated: {{ getCurrentDate() }}</p>
      </div>

      <!-- Agreement Form -->
      <form [formGroup]="privacyForm" class="privacy-form">
        <div class="checkbox-container">
          <label class="checkbox-label">
            <input 
              type="checkbox" 
              formControlName="acceptPrivacyAgreement"
              class="checkbox-input">
            <span class="checkbox-custom"></span>
            <span class="checkbox-text">
              I have read and agree to the Privacy Policy and Terms of Service
            </span>
          </label>
          <div class="error-message" *ngIf="privacyForm.get('acceptPrivacyAgreement')?.invalid && privacyForm.get('acceptPrivacyAgreement')?.touched">
            You must accept the privacy agreement to continue
          </div>
        </div>

        <!-- Error Message -->
        <div class="error-alert" *ngIf="errorMessage">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
            <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
          </svg>
          {{ errorMessage }}
        </div>
      </form>
    </div>

    <!-- Footer -->
    <div class="privacy-popup-footer">
      <button 
        type="button" 
        class="btn btn-secondary"
        (click)="onReject()"
        [disabled]="isLoading">
        Cancel
      </button>
      <button 
        type="button" 
        class="btn btn-primary"
        (click)="onAccept()"
        [disabled]="privacyForm.invalid || isLoading">
        <span *ngIf="isLoading" class="loading-spinner"></span>
        {{ isLoading ? 'Accepting...' : 'Accept & Continue' }}
      </button>
    </div>
  </div>
</div>
